<div class="grid">
  <div class="col-12 col-12 md:col-12">
    <p-accordion
      id="accordion"
      [multiple]="false"
      (onOpen)="abrirAcordeon($event.index)"
    >
      <p-accordionTab
        header="{{ titulo }}"
        [selected]="tabSeleccionado === 'DATGEN'"
      >
        <app-flujo-venta-tab-view
          [tabView]="tabView"
          [listaSecuencias]="listaSecuencias"
          [listaVinculaciones]="listaVinculaciones"
          [lisPasos]="lisPasos"
          [listaTiposPersonas]="listaTiposPersonas"
          [secFija]="false"
          [showControlesTable]="false"
          [HabilitarindicadorVinculacionPorPerfil]="true"
        >
        </app-flujo-venta-tab-view>
      </p-accordionTab>

      <!-- TAB Restricciones Perfil por Vinculación -->
      <p-accordionTab
        header="{{
          'FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_FLUJOVENTARESTRICCIONESPERFILXVINCULACION'
            | translate
        }}"
        [selected]="tabSeleccionado === 'RESPERXVIN'"
        [disabled]="!tabView.flujoVenta?.idFlujoVentaPaso"
        *ngIf="tabView.flujoVenta?.indicadorVinculacionPerfil"
      >
      <app-fv-restricciones-perfil-x-vinculacion [tabView]="tabView"></app-fv-restricciones-perfil-x-vinculacion>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
